import React from 'react';
import { Image } from 'react-bootstrap';

const CustomImage = (props) => {
  // You can add custom logic or modify the props here
  return <Image {...props} />;
};

export default CustomImage;